import React from "react";

function NotFoundPage() {
  return (
    <div className="furniture-page">
      <h1>Not found </h1>
      <p>Not found page</p>
      {/* You can add more HTML or React components to build out this page */}
    </div>
  );
}

export default NotFoundPage;
